import { useState } from 'react';
import ModalContent from '../../components/ModalContent';
import ModalContext from './index';

const ModalProvider = ({ children }) => {
    // variables to handle modal
    const [modalTitle, setModalTitle] = useState('Titulo');
    const [modalBody, setModalBody] = useState('Body');
    const [modalFooter, setModalFooter] = useState(null);
    const [isOpenModal, setIsOpenModal] = useState(false);

    const confirm = (title, body, footer, isOpen) => {
        setModalTitle(title);
        setModalBody(body);
        setModalFooter(footer);
        setIsOpenModal(isOpen);
    }

    return (
        <ModalContext.Provider value={{ setIsOpenModal, confirm }} >
            { children }

            <ModalContent
                title={modalTitle}
                body={modalBody}
                footer={modalFooter}
                isOpenModal={isOpenModal}
                onHide={() => setIsOpenModal(false)}
            />
        </ModalContext.Provider>
    );
}

export default ModalProvider;